import React from "react";
import styles from "../../assets/styles/styles.less";
import MediaQuery from "react-responsive";

import HomeDesktop from "./HomeDesktop";
import HomeMobile from "./HomeMobile";

const Home = () => (
  <div className="home-container">
    <MediaQuery maxDeviceWidth={740}>
      <HomeMobile />
    </MediaQuery>
    <MediaQuery minDeviceWidth={741}>
      <HomeDesktop />
    </MediaQuery>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./components/Home/Home.js